import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash.debounce";
import Pagination from "web/components/Pagination";
import * as moment from "moment";
import CsvDownloader from "react-csv-downloader";

import AlertModal from "web/components/AlertModal";
import DropDown from "web/components/DropDown";
import DatePicker from "web/components/DatePicker";
import MultiSelect from "web/components/MultiSelect";

import { AiOutlineSearch } from "react-icons/ai";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import { Container, Wrapper, TopHeader, SearchWrapper, DateWrapper, FilterWrapper, TableWrapper } from "../myOrderStyled";
import PendingPostsTable from "./PendingPostsTable";
import ScheduledPostsTable from "./ScheduledPostsTable";

import { ptPlusPendingRequestsApi, ptPlusScheduledPostsApi, adminFetchLocationListApi } from 'redux/actions/ptPlusPage'
import { scheduledPostsCsvExportHeader, setScheduledPostsCsvExportData } from '../Constants'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "transparent",
  },
  indicator: {
    background: "#2fb5f1",
  },

  AppBar: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none",
  },
  Tab: {
    textTransform: "capitalize",
    fontSize: "16px",
  },
}));

export default function SimpleTabs({ urlSearchParams, expanded }) {
  let history = useHistory();
  const dispatch = useDispatch();


  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const toggleModal = () => setAlertModal(!alertModal);

  let defaultCompanyList = { label: 'All (Customer name)', value: null }
  // main locations
  const [companyLocationList, setCompanyLocationList] = useState(null);
  const [companyLocationListArray, setCompanyLocationListArray] = useState([defaultCompanyList]);

  // sub locations
  const [companyLocationBusinessList, setCompanyLocationBusinessList] = useState(null);
  const [companyLocationBusinessListArray, setCompanyLocationBusinessListArray] = useState([{ label: 'All (Location Name)', value: null }]);

  // pending post states
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 31);
  toDate.setDate(fromDate.getDate() + 31);
  const [reqFromDate, setFromDate] = useState(fromDate.toISOString().substring(0, 10))
  const [reqToDate, setToDate] = useState(toDate.toISOString().substring(0, 10))
  const [tableSearch, setTableSearch] = useState('')

  // scheduled posts states
  const [reqFromDateSchPost, setFromDateSchPost] = useState(fromDate.toISOString().substring(0, 10))
  const [reqToDateSchPost, setToDateSchPost] = useState(toDate.toISOString().substring(0, 10))
  const statusFilterValueList = [{ label: 'Posted', value: 'POSTED' },
  { label: 'Assigned', value: 'ASSIGNED' }, { label: 'Pending', value: 'PENDING' }, { label: 'Shipped', value: 'SHIPPED' },
  { label: 'Delivered', value: 'DELIVERED' }, { label: 'Picked Up', value: 'PICKEDUP' }, { label: 'Claim', value: 'CLAIM' }, { label: 'Complete', value: 'COMPLETE' },
  { label: 'Rescheduled', value: 'RESCHEDULED' }, { label: 'Canceled', value: 'CANCELLED' }, { label: 'Hold', value: 'HOLD' }]
  const [statusFilterValue, setStatusFilterValue] = useState()
  const [tableSearchScheduledPost, setTableSearchScheduledPost] = useState('')
  const [excludeCompletedCheckBoxState, setExcludeCompletedCheckBoxState] = useState(false)
  const [scheduledPostsSortState, setScheduledPostsSortState] = useState({
    sortColumn: 'RDD',
    sortValue: 'DESC'
  })

  const [pagedataPendingPosts, setPageDataPendingPosts] = useState()
  const [currentPagePendingPosts, setCurrentPagePendingPosts] = useState(1)
  const [totalPagesPendingPosts, setTotalpagesPendingPosts] = useState(0)
  const [pagedataScheduledPosts, setPageDataScheduledPosts] = useState()
  const [currentPageScheduledPosts, setCurrentPageScheduledPosts] = useState(1)
  const [totalPagesScheduledPosts, setTotalpagesScheduledPosts] = useState(0)
  const [exportCSVDataScheduledPosts, setExportCSVDataScheduledPosts] = useState([])
  const [isExporting, setIsExporting] = useState(false)

  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchLocationListFunc()
  }, [])

  useEffect(() => {
    if (value === 0) fetchPendingRequestsData()
    else fetchScheduledPostsData()
  }, [currentPagePendingPosts, currentPageScheduledPosts, companyLocationList, companyLocationBusinessList, statusFilterValue, excludeCompletedCheckBoxState]);

  useEffect(() => {
    setCompanyLocationList(null)
    setCompanyLocationBusinessList(null)
    setCompanyLocationBusinessListArray([{ label: 'All (Location Name)', value: null }])
    if (value === 0) fetchPendingRequestsData()
    else fetchScheduledPostsData()
  }, [value])

  const fetchLocationListFunc = async () => {
    const token = localStorage.getItem("token")
    let response = await dispatch(adminFetchLocationListApi(token));
    if (response?.success) {
      let locationTemp = response?.data?.customerAndLocations;
      let locationTempData = []
      locationTempData = locationTemp.sort((a, b) => {
        return a.customer?.localeCompare(b.customer)
      })
      locationTempData = locationTempData?.map(items => {
        return (
          {
            label: items.customer,
            value: items.customerId,
            subLocationsList: items.locationIdAndNames
          }
        )
      })
      locationTempData.unshift(defaultCompanyList)
      setCompanyLocationListArray(locationTempData.flat())
    }
  }

  const fetchPendingRequestsData = async (parameters) => {
    let response
    const token = localStorage.getItem('token')
    let fromDateValue = parameters ? parameters.fromDate : reqFromDate
    let toDateValue = parameters ? parameters.toDate : reqToDate
    let searchValue = parameters ? parameters.searchText : tableSearch
    let companyLocationBusinessListValue = parameters ? parameters.companyLocationBusinessList : companyLocationBusinessList
    let companyLocationBusinessListArrayValue = parameters ? parameters.companyLocationBusinessListArray : companyLocationBusinessListArray
    let locationsListTemp = null
    if (fromDateValue === 'Invalid date' || toDateValue === 'Invalid date') return false
    if (companyLocationBusinessListValue) {
      // if a particular Sub Location is chosen that is passed
      locationsListTemp = [companyLocationBusinessListValue]
    } else if (companyLocationBusinessListArrayValue?.length > 0 && companyLocationBusinessListArrayValue[0].value && companyLocationBusinessListArrayValue[0].value !== '') {
      // else if one company is chosen and not sublocation is selected entire location list is passed
      locationsListTemp = companyLocationBusinessListArrayValue?.map(items => items.value)
    }
    let data = {
      size: 10,
      number: currentPagePendingPosts - 1,
      sort: 'DESC',
      searchBy: searchValue,
      fromDate: moment(fromDateValue).format('YYYY/MM/DD'),
      toDate: moment(toDateValue).format('YYYY/MM/DD'),
      locations: locationsListTemp
    }
    response = await dispatch(ptPlusPendingRequestsApi(data, token))
    if (response?.success) {
      setPageDataPendingPosts(response.data?.orderLists)
      setTotalpagesPendingPosts(response.data?.totalElements)
      if (!response.data?.orderLists) {
        setPageDataPendingPosts([])
        setTotalpagesPendingPosts(0)
      }
    } else {
      setPageDataPendingPosts()
      if (response?.data?.error?.message === "Invalid Token" || response?.data?.error?.message === 'Request failed with status code 401') {
        history.push('/sign-in')
        window.location.reload(false);
      } else if (response?.data?.error?.message === "Data not found.") {
        setPageDataPendingPosts([])
        setTotalpagesPendingPosts(0)
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
        setAlertModal(!alertModal)
      }
    }
  }

  const fetchScheduledPostsData = async (parameters) => {
    let response
    const token = localStorage.getItem('token')
    let companyLocationBusinessListValue = parameters?.companyLocationBusinessList ? parameters.companyLocationBusinessList : companyLocationBusinessList
    let companyLocationBusinessListArrayValue = parameters?.companyLocationBusinessListArray ? parameters.companyLocationBusinessListArray : companyLocationBusinessListArray
    let locationsListTemp = null
    if (companyLocationBusinessListValue) {
      // if a particular Sub Location is chosen that is passed
      locationsListTemp = [companyLocationBusinessListValue]
    } else if (companyLocationBusinessListArrayValue?.length > 0 && companyLocationBusinessListArrayValue[0].value && companyLocationBusinessListArrayValue[0].value !== '') {
      // else if one company is chosen and not sublocation is selected entire location list is passed
      locationsListTemp = companyLocationBusinessListArrayValue?.map(items => items.value)
    }
    let fromDateValue = parameters?.fromDate ? parameters.fromDate : reqFromDateSchPost
    let toDateValue = parameters?.toDate ? parameters.toDate : reqToDateSchPost
    let filterByValue = parameters?.filterBy ? parameters.filterBy : (statusFilterValue ? statusFilterValue?.map(data => data.value) : ['ALL'])
    if (fromDateValue === 'Invalid date' || toDateValue === 'Invalid date') return false
    let data = {
      fromDate: moment(fromDateValue).format('YYYY/MM/DD'),
      toDate: moment(toDateValue).format('YYYY/MM/DD'),
      currentPage: currentPageScheduledPosts - 1,
      locations: locationsListTemp,
      searchText: parameters?.searchText ? parameters?.searchText : tableSearchScheduledPost,
      filterBy: filterByValue,
      excludeCompleted: parameters?.excludeCompletedCheckBoxStateValue ? parameters?.excludeCompletedCheckBoxStateValue : excludeCompletedCheckBoxState,
      sortType: parameters?.sortValue
        ? parameters.sortValue !== 'normal' ? parameters.sortColumn : 'RDD'
        : scheduledPostsSortState?.sortValue !== 'normal' ? scheduledPostsSortState.sortColumn : 'RDD',
      sort: parameters?.sortValue
        ? parameters.sortValue !== 'normal' ? parameters.sortValue : 'DESC'
        : scheduledPostsSortState?.sortValue !== 'normal'
          ? scheduledPostsSortState.sortValue : 'DESC',
    }
    response = await dispatch(ptPlusScheduledPostsApi(data, token))
    if (response?.success) {
      setPageDataScheduledPosts(response.data?.orderLists)
      setTotalpagesScheduledPosts(response.data?.totalElements)
      if (!response.data?.orderLists) {
        setPageDataScheduledPosts([])
        setTotalpagesScheduledPosts(0)
      }
    } else {
      setPageDataScheduledPosts()
      if (response?.data?.error?.message === "Invalid Token" || response?.data?.error?.message === 'Request failed with status code 401') {
        history.push('/sign-in')
        window.location.reload(false);
      } else if (response?.data?.error?.message === "Data not found.") {
        setPageDataScheduledPosts([])
        setTotalpagesScheduledPosts(0)
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
        setAlertModal(!alertModal)
      }
    }
  }

  const fetchAllScheduledPostsDataForExport = async () => {
    setIsExporting(true)
    let allData = [];
    let token = localStorage.getItem('token');
    let companyLocationBusinessListValue = companyLocationBusinessList;
    let companyLocationBusinessListArrayValue = companyLocationBusinessListArray;
    let locationsListTemp = null;

    if (companyLocationBusinessListValue) {
      locationsListTemp = [companyLocationBusinessListValue];
    } else if (companyLocationBusinessListArrayValue?.length > 0 && companyLocationBusinessListArrayValue[0].value && companyLocationBusinessListArrayValue[0].value !== '') {
      locationsListTemp = companyLocationBusinessListArrayValue.map(items => items.value);
    }

    let fromDateValue = reqFromDateSchPost;
    let toDateValue = reqToDateSchPost;
    let filterByValue = statusFilterValue ? statusFilterValue.map(data => data.value) : ['ALL'];
    let pageNumber = 0;
    let totalPages = 1;
    const pageSize = 10;

    while (pageNumber < totalPages) {
      let data = {
        size: pageSize,
        currentPage: pageNumber,
        searchText: tableSearchScheduledPost,
        fromDate: moment(fromDateValue).format('YYYY/MM/DD'),
        toDate: moment(toDateValue).format('YYYY/MM/DD'),
        filterBy: filterByValue,
        locations: locationsListTemp,
        excludeCompleted: excludeCompletedCheckBoxState,
        sortType: scheduledPostsSortState?.sortValue && scheduledPostsSortState?.sortValue !== 'normal' ? scheduledPostsSortState?.sortColumn : null,
        sort: scheduledPostsSortState?.sortValue && scheduledPostsSortState?.sortValue !== 'normal' ? scheduledPostsSortState?.sortValue : null,
      };
      let response = await dispatch(ptPlusScheduledPostsApi(data, token));
      if (response?.success) {
        let orders = response.data?.orderLists || [];
        allData.push(...orders);
        totalPages = Math.ceil(response.data?.totalPages);
      } else {
        break;
      }
      pageNumber++;
    }
    // set the export data
    let exportData = setScheduledPostsCsvExportData(allData || []);
    setExportCSVDataScheduledPosts(exportData)
    document.getElementById('scheduledPostsExportRef').click();
    setIsExporting(false)
  };

  const onPageChangeFunction = (pageNumber, type) => {
    if (type === 'pending') setCurrentPagePendingPosts(pageNumber);
    else if (type === 'scheduled') setCurrentPageScheduledPosts(pageNumber);
  };

  const handleValueChange = (e, type) => {
    setCurrentPagePendingPosts(1)
    // we are setting the values here and passing to the function because of the usage of callback function in the following function. Callback takes the values decalred intially otherwise.
    let parameters = {
      fromDate: reqFromDate,
      toDate: reqToDate,
      searchText: tableSearch,
      companyLocationBusinessList: companyLocationBusinessList,
      companyLocationBusinessListArray: companyLocationBusinessListArray
    }
    if (type === 'searchField') {
      setTableSearch(e.target.value)
      parameters.searchText = e.target.value
    } else if (type === 'fromDate') {
      parameters.fromDate = e
    } else if (type === 'toDate') {
      parameters.toDate = e
    }
    handleDebounceSearch(parameters);
  }
  const handleDebounceSearch = useCallback(debounce((parameters) => fetchPendingRequestsData(parameters), 500), []);

  const handleValueChangeSchPost = (e, type) => {
    setCurrentPageScheduledPosts(1)
    // we are setting the values here and passing to the function because of the usage of callback function in the following function. Callback takes the values decalred intially otherwise.
    let parameters = {
      fromDate: reqFromDateSchPost,
      toDate: reqToDateSchPost,
      searchText: tableSearchScheduledPost,
      companyLocationBusinessList: companyLocationBusinessList,
      companyLocationBusinessListArray: companyLocationBusinessListArray,
      filterBy: statusFilterValue ? statusFilterValue?.map(data => data.value) : ['ALL'],
      sortColumn: scheduledPostsSortState?.sortColumn,
      sortValue: scheduledPostsSortState?.sortValue,
      excludeCompletedCheckBoxStateValue: excludeCompletedCheckBoxState,
    }
    if (type === 'searchField') {
      setTableSearchScheduledPost(e.target.value)
      parameters.searchText = e.target.value
    } else if (type === 'fromDate') {
      parameters.fromDate = e
    } else if (type === 'toDate') {
      parameters.toDate = e
    }
    handleDebounceSearchScheduledPost(parameters);
  }
  const handleDebounceSearchScheduledPost = useCallback(debounce((parameters) => fetchScheduledPostsData(parameters), 500), []);

  return (
    <section>
      <div style={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px 0px' }}>
        <TopHeader>
          <h6>{value === 0 ? 'Pending Requests' : 'Scheduled Orders'}</h6>
          <div className="top-header-container">
            <div className="main-location-wrapper">
              <DropDown
                name="companyLocationList"
                data={companyLocationListArray}
                searchDropDown={companyLocationList}
                searchable={true}
                placeholder='Customer Name'
                onChangeHandler={(data) => {
                  setCompanyLocationList(data.value)
                  setCurrentPagePendingPosts(1)
                  setCurrentPageScheduledPosts(1)

                  // setting the sublocations based on main
                  setCompanyLocationBusinessList(null)
                  let subLocationListTemp = data?.subLocationsList?.map(data => ({ label: data.locationName, value: data.locationId }))
                  if (data.value === null) setCompanyLocationBusinessListArray([{ label: 'All (Location Name)', value: null }])
                  else setCompanyLocationBusinessListArray(subLocationListTemp)
                }}
              />
            </div>
            <div className="sub-location-wrapper">
              <DropDown
                name="companyLocationBusinessList"
                data={companyLocationBusinessListArray}
                searchDropDown={companyLocationBusinessList}
                searchable={true}
                placeholder='Location Name'
                onChangeHandler={(data) => {
                  setCurrentPagePendingPosts(1)
                  setCurrentPageScheduledPosts(1)
                  setCompanyLocationBusinessList(data.value)
                }}
              />
            </div>
          </div>
        </TopHeader>
      </div>

      <Container>
        {value === 0 ?
          <FilterWrapper>
            <DateWrapper>
              <div>
                <DatePicker type='returnNormalDate' name="fromDate" value={reqFromDate} maxDOBirth={reqToDate}
                  callBackFun={(date) => {
                    setFromDate(moment(date).format('MM/DD/YYYY'))
                    handleValueChange(moment(date).format('MM/DD/YYYY'), 'fromDate')
                  }} />
                <p style={{ 'margin-top': '5px' }}>To</p>
                <DatePicker type='returnNormalDate' name="toDate" value={reqToDate} minDOBirth={reqFromDate}
                  callBackFun={(date) => {
                    setToDate(moment(date).format('MM/DD/YYYY'))
                    handleValueChange(moment(date).format('MM/DD/YYYY'), 'toDate')
                  }} />
              </div>
            </DateWrapper>
            <SearchWrapper>
              <input type="text" placeholder='Search' value={tableSearch}
                onChange={(e) => handleValueChange(e, 'searchField')} />
              <AiOutlineSearch />
            </SearchWrapper>
          </FilterWrapper>
          :
          <FilterWrapper>
            <DateWrapper>
              <div className="date-style-class">
                <DatePicker type='returnNormalDate' name="fromDate" value={reqFromDateSchPost} maxDOBirth={reqToDateSchPost}
                  callBackFun={(date) => {
                    setFromDateSchPost(moment(date).format('MM/DD/YYYY'))
                    handleValueChangeSchPost(moment(date).format('MM/DD/YYYY'), 'fromDate')
                  }} />
                <p style={{ 'margin-top': '5px' }}>To</p>
                <DatePicker type='returnNormalDate' name="toDate" value={reqToDateSchPost} minDOBirth={reqFromDateSchPost}
                  callBackFun={(date) => {
                    setToDateSchPost(moment(date).format('MM/DD/YYYY'))
                    handleValueChangeSchPost(moment(date).format('MM/DD/YYYY'), 'toDate')
                  }} />
              </div>
            </DateWrapper>
            <div className="post-filter-wrapper">
              <MultiSelect
                name="scheduledPostStatusFilter"
                data={statusFilterValueList}
                multiSelectVal={statusFilterValue}
                defaultValueArr={statusFilterValue}
                placeholder='All'
                isSearchable={false}
                onChangeHandler={(data) => {
                  setCurrentPageScheduledPosts(1)
                  setStatusFilterValue(data)
                }}
              />
            </div>
            <SearchWrapper>
              <input type="text" placeholder='Search' value={tableSearchScheduledPost}
                onChange={(e) => handleValueChangeSchPost(e, 'searchField')} />
              <AiOutlineSearch />
            </SearchWrapper>
            <div className="check-box-class">
              <label className='checkbox-container' style={{ margin: '10px' }}>
                <input
                  type='checkbox'
                  checked={excludeCompletedCheckBoxState}
                  onClick={(event) => {
                    setCurrentPageScheduledPosts(1)
                    setExcludeCompletedCheckBoxState(event.target.checked)
                  }}
                />
                <span className='checkMark'></span>
                Exclude Completed
              </label>
            </div>
            <div className="export-csv-style">
              <button
                onClick={fetchAllScheduledPostsDataForExport}
              >{isExporting ? 'Exporting...' : 'Export'}
              </button>
              <CsvDownloader
                filename="Scheduled Posts Report"
                columns={scheduledPostsCsvExportHeader}
                datas={exportCSVDataScheduledPosts}
              >
                <button
                  id='scheduledPostsExportRef'
                  style={{ display: 'none' }}
                >Export</button>
              </CsvDownloader>
            </div>
          </FilterWrapper>
        }
        <Wrapper>
          <AppBar position="static" className={classes.AppBar}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              variant={"scrollable"}
              scrollButtons={"on"}
            >
              <Tab
                label='Pending Requests'
                {...a11yProps(0)}
              />
              <Tab
                label='Scheduled Orders'
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            {(
              <TableWrapper>
                <div>
                  <PendingPostsTable
                    pagedata={pagedataPendingPosts}
                    deleteCallBack={fetchPendingRequestsData}
                    requestTendorCallBack={() => setValue(1)}
                  />
                </div>
              </TableWrapper>
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
            {(
              <TableWrapper>
                <div>
                  <ScheduledPostsTable
                    pagedata={pagedataScheduledPosts}
                    scheduledPostsSortState={scheduledPostsSortState}
                    fetchDataCallBack={(value, type) => {
                      if (type === 'refreshData') {
                        fetchScheduledPostsData()
                      } else if (type === 'sortingChange') {
                        let parameters = { ...value }
                        setScheduledPostsSortState(value)
                        setCurrentPageScheduledPosts(1)
                        fetchScheduledPostsData(parameters)
                      }
                    }}
                  />
                </div>
              </TableWrapper>
            )}
          </TabPanel>
        </Wrapper>
      </Container>

      {value === 0 && pagedataPendingPosts && pagedataPendingPosts.length > 0 && (
        <Pagination
          currentPage={currentPagePendingPosts}
          totalPage={totalPagesPendingPosts}
          itemsCountPerPage={10}
          onPageChange={(value) => {
            onPageChangeFunction(value, 'pending');
          }}
        />
      )}

      {value === 1 && pagedataScheduledPosts && pagedataScheduledPosts.length > 0 && (
        <Pagination
          currentPage={currentPageScheduledPosts}
          totalPage={totalPagesScheduledPosts}
          itemsCountPerPage={10}
          onPageChange={(value) => {
            onPageChangeFunction(value, 'scheduled');
          }}
        />
      )}

      <AlertModal
        isOpen={alertModal}
        toggle={toggleModal}
        title=''
        content={alertModalContent}
        link=''
      />

    </section>
  );
}
